<div class="relative mb-6">
  <button
    class="w-full"
    type="button"
    tuiButton
    appearance="outline-grayscale"
    tuiAppearanceMode="checked"
    size="m"
    (click)="openMistakesModal()"
    [disabled]="!canExecute()"
  >
    {{ field().title || ('workflows.mistakes_button' | translate) }}
  </button>
</div>
